import { RemoteStatusEntry, WCStatusQueryMsg, WCStatusQueryQuery } from '../../autogenerated/ZoomBridge';
import System from '../../basic/System';
import ViewUtil from '../../ViewUtil';
import _ from 'lodash';
import Store from '../../store/Store';
import { BREADCRUMB_ASSETS, GLOBAL_SEARCH_INFO } from '../../store/Constants';

const debug = require('../../debug/debug')('wc:queries:RemoteFileStatusHandler');

export default class RemoteFileStatusHandler {
  static INSTANCE: RemoteFileStatusHandler;

  static getInstance(): RemoteFileStatusHandler {
    return this.INSTANCE;
  }

  constructor() {}

  resetAndSubmitFile(
    inFiles: Array,
    rootFuid: number,
    forceUpdate: boolean = true,
    pageid: string = undefined,
    pageNumber: number = -1
  ): Promise<any> {
    return new Promise((onSuccess, onFailure) => {
      this.run(inFiles, rootFuid, forceUpdate, onSuccess, onFailure, true, pageid, pageNumber);
    });
  }

  submitFiles(
    inFiles: Array,
    rootFuid: number,
    forceUpdate: boolean = true,
    pageId: string = undefined,
    pageNumber: number = -1
  ): Promise<any> {
    return new Promise((onSuccess, onFailure) => {
      this.run(inFiles, rootFuid, forceUpdate, onSuccess, onFailure, false, pageId, pageNumber);
    });
  }

  scheduleFiles() {
    if (this._loadingStatus) {
      clearTimeout(this._loadingStatus);
    }
    this._loadingStatus = setTimeout(() => {
      const itemsForStatusCache = Store.get(BREADCRUMB_ASSETS);
      if (itemsForStatusCache && itemsForStatusCache.length) {
        RemoteFileStatusHandler.getInstance()
          .resetAndSubmitFile(itemsForStatusCache, -1)
          .then();
      }
    }, 500);
  }

  /* *
   * WC_STATUS_QUERY vals
   * 1= ongoing
   * 2 = completed
   *
   * RENDER_STATUS
   * 1=pending
   * 2=completed
   * **/

  run(
    inFiles: Array,
    rootFuid: number,
    forceUpdate: boolean,
    onSuccess: Function,
    onFailure: Function,
    reset: boolean,
    pageId: string,
    pageNumber: number
  ): void {
    if (!System.isVAB() || !inFiles || !inFiles.length) {
      onSuccess();
      return;
    }
    let responseStore: Map<number, any> = new Map();
    const query: WCStatusQueryQuery = new WCStatusQueryQuery();
    const msg: WCStatusQueryMsg = new WCStatusQueryMsg();
    let assetEntryArr = [];
    try {
      _.each(inFiles, (item) => {
        if (1 !== item.WC_STATUS_QUERY && (2 !== item.WC_STATUS_QUERY || reset)) {
          if (rootFuid < 0 && !Store.get(GLOBAL_SEARCH_INFO).active) {
            rootFuid = _.last(ViewUtil.getPwd());
          }
          item.WC_STATUS_QUERY = 1;
          item.RENDER_STATUS = 1;

          item.extraInfo = undefined;
          item.wcStatusObject = undefined;

          responseStore.set(item.getFuid(), item);
          const ae: RemoteStatusEntry = new RemoteStatusEntry();
          ae.setFuid(item.getFuid());
          ae.setFqPath(item.getRemotePath());
          ae.setProject(item.getProject());
          ae.setRrn(item.getRrn());

          assetEntryArr.push(ae);
        }
      });
    } catch (e) {
      return;
      //console.error('Error Unable to fatch status');
    }

    if (assetEntryArr.length === 0) {
      onSuccess();
      return;
    }
    const instanceThis = this;
    let updateStat = false;
    msg.setAssetEntries(assetEntryArr);
    msg.setForceUpdate(forceUpdate);
    msg.setRootFuid(rootFuid);
    msg.setPageId(pageId);
    msg.setPageNumber(pageNumber);
    query.message = msg;
    query
      .run()
      .then(
        (resp) => {
          let items = resp.getItems();
          if (items && items.length > 0) {
            _.each(items, (item) => {
              let repoItem = responseStore.get(item.getFuid());
              repoItem.wcStatusObject = item;
            });
          }
          const fuid2ExtraInfo = resp.getFuid2ExtraInfo();
          if (fuid2ExtraInfo) {
            fuid2ExtraInfo.forEach((fuid, extraInfo) => {
              let repoItem = responseStore.get(fuid);
              repoItem.extraInfo = extraInfo;
            });
          }
          instanceThis.completeStatusQueryStat(inFiles);
          updateStat = true;
          onSuccess();
        },
        (failedResp) => {
          updateStat = true;
          instanceThis.completeStatusQueryStat(inFiles);
          onFailure();
        }
      )
      .finally(function() {
        if (!updateStat) instanceThis.completeStatusQueryStat(inFiles);
      });
  }

  completeStatusQueryStat(inFiles) {
    _.each(inFiles, (item) => {
      item.WC_STATUS_QUERY = 2;
      item.RENDER_STATUS = 1;
    });
  }
}

RemoteFileStatusHandler.INSTANCE = new RemoteFileStatusHandler();
